$(document).on('turbolinks:load', function() {
    const disabledPrefectureNames = ["全国", "海外", "その他", "未選択"];

    const readStoredArray = (key) => {
        try {
            return JSON.parse(localStorage.getItem(key)) || [];
        } catch (_error) {
            localStorage.removeItem(key);
            return [];
        }
    };

    const setCityAvailability = ($form) => {
        const $prefectureSelect = $form.find('select[name="prefecture"]');
        const $citySelect = $form.find('select[name="city"]');
        const selectedPrefectureName = $prefectureSelect.find('option:selected').text();
        const shouldDisable = disabledPrefectureNames.includes(selectedPrefectureName);

        $citySelect.prop('disabled', shouldDisable);
        $citySelect.toggleClass('disabled', shouldDisable);

        if (shouldDisable) {
            $citySelect.empty();
        }
    };

    const loadCities = ($form, prefectureId, cityId) => {
        const $prefectureSelect = $form.find('select[name="prefecture"]');
        const $citySelect = $form.find('select[name="city"]');
        const selectedPrefectureName = $prefectureSelect.find('option:selected').text();

        $citySelect.empty();

        if (disabledPrefectureNames.includes(selectedPrefectureName)) {
            setCityAvailability($form);
            return;
        }

        $citySelect.prop('disabled', false).removeClass('disabled');
        $.ajax({
            url: $form.data('cities-url'),
            method: 'GET',
            data: {prefecture_id: prefectureId},
            dataType: 'json'
        }).done((data) => {
            $citySelect.append($("<option>").val('').text('全域'));
            $.each(data, (_index, city) => {
                $citySelect.append($("<option>").val(city.id).text(city.name));
            });
            $citySelect.val(cityId || '');
        });
    };

    const restoreStoredState = ($form) => {
        const $prefectureSelect = $form.find('select[name="prefecture"]');
        const savedPrefecture = localStorage.getItem('prefecture');

        if (savedPrefecture && $prefectureSelect.find(`option[value="${savedPrefecture}"]`).length > 0) {
            $prefectureSelect.val(savedPrefecture);
            loadCities($form, savedPrefecture, localStorage.getItem('city'));
        } else {
            setCityAvailability($form);
        }

        const keyword = localStorage.getItem('keyword');
        if (keyword) {
            $form.find('input[name="keyword"]').val(keyword);
        }

        const restoreCheckedValues = (fieldName, storageKey) => {
            const $fields = $form.find(`input[name="${fieldName}[]"]`);
            $fields.prop('checked', false);
            readStoredArray(storageKey).forEach((value) => {
                $fields.filter(`[value="${value}"]`).prop('checked', true);
            });
        };

        restoreCheckedValues('target_users', 'targetUsers');
        restoreCheckedValues('target_items', 'targetItems');
        restoreCheckedValues('target_purposes', 'targetPurposes');

        $form.find('input[name="expand_search"]').prop('checked', localStorage.getItem('expandSearch') === 'true');
        $form.find('input[name="include_unknown_or_closed"]')
            .prop('checked', localStorage.getItem('includeUnknownOrClosed') !== 'false');
    };

    const persistState = ($form) => {
        const keyword = $form.find('input[name="keyword"]').val().trim();
        if (keyword) {
            localStorage.setItem('keyword', keyword);
        } else {
            localStorage.removeItem('keyword');
        }

        const prefecture = $form.find('select[name="prefecture"]').val();
        if (prefecture) {
            localStorage.setItem('prefecture', prefecture);
        } else {
            localStorage.removeItem('prefecture');
        }

        const city = $form.find('select[name="city"]').val();
        if (city) {
            localStorage.setItem('city', city);
        } else {
            localStorage.removeItem('city');
        }

        const storeCheckedValues = (fieldName, storageKey) => {
            const values = $form.find(`input[name="${fieldName}[]"]:checked`).map(function() {
                return this.value;
            }).get();
            localStorage.setItem(storageKey, JSON.stringify(values));
        };

        storeCheckedValues('target_users', 'targetUsers');
        storeCheckedValues('target_items', 'targetItems');
        storeCheckedValues('target_purposes', 'targetPurposes');

        if ($form.find('input[name="expand_search"]').prop('checked')) {
            localStorage.setItem('expandSearch', 'true');
        } else {
            localStorage.removeItem('expandSearch');
        }

        if ($form.find('input[name="include_unknown_or_closed"]').prop('checked')) {
            localStorage.removeItem('includeUnknownOrClosed');
        } else {
            localStorage.setItem('includeUnknownOrClosed', 'false');
        }
    };

    $('.search-form').each(function() {
        const $form = $(this);
        const $prefectureSelect = $form.find('select[name="prefecture"]');
        const isUrlDriven = $form.attr('data-url-driven') === 'true';

        $prefectureSelect.on('change', function() {
            loadCities($form, $(this).val());
        });

        if (isUrlDriven) {
            setCityAvailability($form);
        } else {
            restoreStoredState($form);
        }
    });

    const $urlDrivenForm = $('.search-form[data-url-driven="true"]').first();
    if ($urlDrivenForm.length > 0) {
        persistState($urlDrivenForm);
    }

    $('.search-form').on('submit', function(event) {
        event.preventDefault();
        const $form = $(this);
        const $keywordField = $form.find('input[name="keyword"]');

        persistState($form);

        if (!$keywordField.val().trim()) {
            $keywordField.removeAttr('name');
        }

        const $citySelect = $form.find('select[name="city"]');
        if ($citySelect.find('option:selected').text().includes('全域')) {
            $citySelect.removeAttr('name');
        }

        const $prefectureSelect = $form.find('select[name="prefecture"]');
        if ($prefectureSelect.find('option:selected').text().includes('未選択')) {
            $prefectureSelect.removeAttr('name');
        }

        const $searchButton = $form.find('.search-btn');
        $searchButton.prop('disabled', true);
        $searchButton.find('.spinner-border').removeClass('d-none');
        const labelNode = $searchButton.contents().filter((_, node) => node.nodeType === 3 && node.textContent.trim() !== '').get(0);
        if (labelNode) labelNode.textContent = ' 検索中...';

        this.submit();
    });

    $('.clear-search-condition').on('click', function(event) {
        event.preventDefault();

        [
            'keyword', 'prefecture', 'city', 'targetUsers', 'targetItems',
            'targetPurposes', 'expandSearch', 'includeUnknownOrClosed'
        ].forEach((key) => localStorage.removeItem(key));

        $('.search-form').each(function() {
            const $form = $(this);
            $form.find('input[name="keyword"]').val('');
            $form.find('select[name="prefecture"]').val('');
            $form.find('select[name="city"]').empty().prop('disabled', true).addClass('disabled');
            $form.find('input[name="target_users[]"], input[name="target_items[]"], input[name="target_purposes[]"]')
                .prop('checked', false);
            $form.find('input[name="expand_search"]').prop('checked', false);
            $form.find('input[name="include_unknown_or_closed"]').prop('checked', true);
        });
    });
});
